// ProgressBar.js
import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ passoAtual }) => {
    return (
        <div className="barra-progresso">
            <div className={`etapa ${passoAtual === 1 && 'etapaAtual'}`}>1</div>
            <div className={`etapa ${passoAtual === 2 && 'etapaAtual'}`}>2</div>
            <div className={`etapa ${passoAtual === 3 && 'etapaAtual'}`}>3</div>
        </div>
    );
};

export default ProgressBar;
